import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppDataService, StoreService } from 'app/services';
import { MessageService } from 'primeng/api';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'product-availability',
  templateUrl: './product-availability.component.html',
  styleUrls: ['./product-availability.component.scss'],
  providers: [MessageService],
})
export class ProductAvailabilityComponent implements OnInit {
  @Input() availabilityControl!: FormControl;
  @Input() storeSelectedSet = new Set<any>();
  @Output() createProduct = new EventEmitter<any>();

  storeSelectedTemp: any;
  options: any[] = []; // TODO Create StoreLocation model
  filteredOptions!: Observable<any[]>;

  constructor(
    private storeService: StoreService,
    private appData: AppDataService,
    private messageService: MessageService
  ) {}

  // Parameter type any to get the option class and the value selected
  addStoreSelected(store: any) {
    this.storeSelectedSet.add(this.storeSelectedTemp);
    this.availabilityControl.setValue('');
  }

  ngOnInit(): void {
    this.getStoresByMerchant();
    // Auto complete filter
    this.filteredOptions = this.availabilityControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filter(value || ''))
    );
  }

  private filter(value: any): string[] {
    const filterValue = value.toString().toLowerCase();

    return this.options.filter((option) =>
      option.Name.toLowerCase().includes(filterValue)
    );
  }

  getStoresByMerchant() {
    const dto = {
      MerchantId: this.appData.authData.MerchantId,
    };

    this.storeService
      .getStoresByMerchant(dto, this.messageService)
      .then((data) => {
        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }
        //this.stores = data.Items;
        this.options = data.Items;
      })
      .catch((err) => {
        //this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err,
        });
      });
  }

  removeExcludeStore(store: any) {
    this.storeSelectedSet.delete(store);
  }

  onCreateProduct() {
    this.createProduct.emit();
  }
}
